<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Date"><br>
                                    <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <base-input label="Per Account">
                                    <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All" style="width: 100%" changeOnSelect/>
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Select Branch">
                                    <a-select mode="multiple" v-model="inputBranch" showSearch placeholder="All Branches" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                        <a-select-option v-for="option in branchOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <base-input label="Status">
                                    <select class="form-control" size="large" v-model="inputStatus">
                                        <option v-for="option in statusOptions" v-bind:value="option.key" v-bind:key="option.key">
                                            {{ option.value }}
                                        </option>
                                    </select>
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;

                                <vue-json-to-csv v-if="JsonData.length > 0" :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="JsonData = []"> Download CSV </button> &nbsp; &nbsp;
                                </vue-json-to-csv>
                                <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateExcel"> Download Excel </button> &nbsp; &nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage.js';
    import reportUtils from '../../components/reportUtils.js'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";

    import {
        mapState,
        mapActions
    } from 'vuex'

    var component_x;

    export default {
        components: {
            VueJsonToCsv
        },
        data() {
            return {
                spinning: false,
                inputDate: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
                inputLocation: [],
                locationOptions: [],
                inputBranch: [],
                branchOptions: [],
                inputStatus: '',
                statusOptions: [
                    {key: 'Posted', value: 'Posted'},
                    {key: 'Voided', value: 'Voided'},
                    {key: 'Saved', value: 'Saved'},
                    {key: 'Confirmed', value: 'Confirmed'},
                    {key: '', value: 'All'},
                ],
                currDate: moment().format("L_LT").split(":").join(";"),
                JsonData: []
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.branchOptions = sites;
            component_x.sort(component_x.branchOptions);
            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
        },
        computed: {
            ...mapState(['currentProfile', 'endPoint']),
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            async onLocationChange(){
                var location = this.inputLocation[this.inputLocation.length - 1]
                if(!location){
                    this.handleClearInputLocation()
                } else {
                    const sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                    this.branchOptions = sites;
                    this.sort(this.branchOptions);
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                    this.inputBranch = [];
                }
            },
            async handleClearInputLocation() {
                var userId = secureStorage.getItem("userId");
                var sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                this.branchOptions = sites;
                this.sort(this.branchOptions);
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputBranch = [];
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            // Resolve the site_id filter. When specific branches are selected, use them.
            // When "All Branches" is left but a Per Account (location) is selected, scope to
            // that location's branches (branchOptions) so the export is not for all system sites.
            getEffectiveSiteIds(){
                if (this.inputBranch && this.inputBranch.length > 0) {
                    return this.inputBranch.toString()
                }
                var hasLocation = this.inputLocation && this.inputLocation.length > 0
                if (hasLocation && Array.isArray(this.branchOptions) && this.branchOptions.length > 0) {
                    return this.branchOptions.map(function(s){ return s.id }).toString()
                }
                return ''
            },
            generateReport: async function () {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)

                let filter_header = ''
                filter_header = filter_header.concat("Status: ", this.statusOptions.find(x => x.key === this.inputStatus).value)

                let parameters = {
                    "site_id": this.getEffectiveSiteIds(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "status": this.inputStatus
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'atlas_consolidated_stock_request_report?', parameters);

                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    this.spinning = false;
                    return
                }
                var reportData_all = get_request;

                if(reportData_all.length > 0){
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    let headers = [
                        [
                            {content: 'Date', styles: {halign: 'center', valign: 'auto'}},
                            {content: 'Branch', styles: {halign: 'center', valign: 'auto'}},
                            {content: 'Reference #', styles: {halign: 'center', valign: 'auto'}},
                            {content: 'Per Account', styles: {halign: 'center', valign: 'auto'}},
                            {content: 'Product Code', styles: {halign: 'center', valign: 'auto'}},
                            {content: 'Product Code', styles: {halign: 'center', valign: 'auto'}},
                            {content: 'Product Name', styles: {halign: 'center', valign: 'auto'}},
                            {content: 'Category', styles: {halign: 'center', valign: 'auto'}},
                            {content: 'Uom', styles: {halign: 'center', valign: 'auto'}},
                            {content: 'Quantity', styles: {halign: 'center', valign: 'auto'}},
                            {content: 'Status', styles: {halign: 'center', valign: 'auto'}},
                            {content: 'Posted By', styles: {halign: 'center', valign: 'auto'}}
                        ]
                    ]

                    for(let x = 0; x < reportData_all.length; x++){
                        let report_details = reportData_all[x].report_details

                        if(x > 0 && report_details.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(report_details.length > 0){
                            for(let i = 0; i < report_details.length; i++){
                                let reportLine = report_details[i]

                                let detail = [
                                    reportLine.document_date,
                                    reportLine.branch,
                                    reportLine.reference_number,
                                    reportLine.per_account,
                                    reportLine.product_code,
                                    reportLine.product_code_2,
                                    reportLine.product_name,
                                    reportLine.category,
                                    reportLine.uom,
                                    reportLine.quantity,
                                    reportLine.status,
                                    reportLine.posted_by
                                ]
                                reportData.push(Object.assign({}, detail))
                            }
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15, 20, "Atlas Consolidated Stock Request Report")
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        doc.text(15, 25, "For the Period of " + from_header + " to " + to_header)
                        doc.text(15, 30, "Filtered by: " + filter_header)

                        let colStyles = {
                            0: {cellWidth: 'auto', halign: 'center'},
                            1: {cellWidth: 'auto', halign: 'left'},
                            2: {cellWidth: 'auto', halign: 'center'},
                            3: {cellWidth: 'auto', halign: 'left'},
                            4: {cellWidth: 'auto', halign: 'center'},
                            5: {cellWidth: 'auto', halign: 'center'},
                            6: {cellWidth: 'auto', halign: 'left'},
                            7: {cellWidth: 'auto', halign: 'left'},
                            8: {cellWidth: 'auto', halign: 'center'},
                            9: {cellWidth: 'auto', halign: 'right'},
                            10: {cellWidth: 'auto', halign: 'center'},
                            11: {cellWidth: 'auto', halign: 'left'}
                        }

                        doc.autoTable({
                            startY: 40,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'auto',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: { bottom: 30 },
                            styles: {
                                cellPadding: 1.3, fontSize: 8,
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                }
                            }
                        });
                    }

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    for(let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Atlas Consolidated Stock Request Report", 330, 200, i, pageCount)
                    }
                    doc.save(`AtlasConsolidatedStockRequestReport_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning = false;
            },
            async generateExcel(){
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("Atlas Consolidated Stock Request Report", {
                    pageSetup:{paperSize: 9}
                });

                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let filter_header = ''
                filter_header = filter_header.concat("Status: ", this.statusOptions.find(x => x.key === this.inputStatus).value)

                const data_starts_at_row = 7

                sheet.getRow(4).values = [`Atlas Consolidated Stock Request Report`]
                sheet.getRow(5).values = [`For the Period of ${from_header} to ${to_header}`]
                sheet.getRow(6).values = [`Filtered by: ${filter_header}`]

                sheet.getRow(data_starts_at_row).values = [
                    "Date", "Branch", "Reference #", "Per Account", "Product Code", "Product Code", "Product Name", "Category", "Uom", "Quantity", "Status", "Posted By"
                ];
                sheet.columns = [
                    { key: "date", width: 15 },
                    { key: "branch", width: 20 },
                    { key: "reference_number", width: 18 },
                    { key: "per_account", width: 20 },
                    { key: "product_code", width: 18 },
                    { key: "product_code_2", width: 18 },
                    { key: "product_name", width: 30 },
                    { key: "category", width: 20 },
                    { key: "uom", width: 12 },
                    { key: "quantity", width: 12 },
                    { key: "status", width: 12 },
                    { key: "posted_by", width: 15 }
                ];

                var report_details = this.JsonData
                var rowDatas = []

                for(let i = 0; i < report_details.length; i++){
                    const report_detail = report_details[i]
                    if(report_detail){
                        let rowData = {
                            date: report_detail["Date"],
                            branch: report_detail["Branch"],
                            reference_number: report_detail["Reference #"],
                            per_account: report_detail["Per Account"],
                            product_code: report_detail["Product Code (1st)"],
                            product_code_2: report_detail["Product Code (2nd)"],
                            product_name: report_detail["Product Name"],
                            category: report_detail["Category"],
                            uom: report_detail["Uom"],
                            quantity: report_detail["Quantity"],
                            status: report_detail["Status"],
                            posted_by: report_detail["Posted By"]
                        }
                        rowDatas.push(rowData)
                    }
                }

                sheet.addRows(rowDatas);

                //styles
                sheet.getRow(4).font = { bold: true, size: 16 };
                sheet.getRow(4).height = 20;
                sheet.getRow(data_starts_at_row).font = { bold: true };

                sheet.eachRow(function (Row, rowNum) {
                    if(rowNum >= data_starts_at_row){
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = {
                                    horizontal: 'center'
                                }
                            } else {
                                Cell.alignment = {
                                    vertical: 'middle',
                                    horizontal: 'left'
                                }
                            }
                        })
                    }
                })

                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                    saveAs(blob, `AtlasConsolidatedStockRequestReport.xlsx`);
                });
                this.JsonData = []
            },
            generateFile: async function() {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let filter_header = ''
                filter_header = filter_header.concat("Status: ", this.statusOptions.find(x => x.key === this.inputStatus).value)

                let parameters = {
                    "site_id": this.getEffectiveSiteIds(),
                    "date_from": from_date,
                    "date_to": to_date,
                    "status": this.inputStatus
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'atlas_consolidated_stock_request_report?', parameters);

                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    this.spinning = false;
                    return
                }

                if(get_request.length > 0){
                    let reportData_all = get_request;
                    let headers = ["Date", "Branch", "Reference #", "Per Account", "Product Code (1st)", "Product Code (2nd)", "Product Name", "Category", "Uom", "Quantity", "Status", "Posted By"];

                    let site_specific = [];

                    for(let x = 0; x < reportData_all.length; x++){
                        let report_details = reportData_all[x].report_details

                        let reportData = [];
                        if(x > 0){
                            reportData.push(headers)
                        }
                        if(report_details.length > 0){
                            for(let i = 0; i < report_details.length; i++){
                                let reportLine = report_details[i]
                                let detail = [
                                    reportLine.document_date,
                                    reportLine.branch,
                                    reportLine.reference_number,
                                    reportLine.per_account,
                                    reportLine.product_code,
                                    reportLine.product_code_2,
                                    reportLine.product_name,
                                    reportLine.category,
                                    reportLine.uom,
                                    reportLine.quantity,
                                    reportLine.status,
                                    reportLine.posted_by
                                ]
                                reportData.push(Object.assign({}, detail))
                            }
                        }

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData = [];

                        for(var i = 0; i < values_length; i++){
                            var result = Object.assign.apply({}, keys.map((val, index) => ({
                                [val]: values[i][index]
                            })));
                            newJsonData.push(result)
                        }

                        newJsonData.forEach(function(obj) {
                            for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null) {
                                    obj[i] = '';
                                }
                            }
                        });
                        site_specific.push(newJsonData)
                    }

                    this.JsonData = site_specific.flat()
                } else {
                    reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning = false;
            }
        }
    };
</script>

<style></style>
